import { useRouter } from "next/router";

import ButtonV2 from "@/components/shared/buttonV2";
import Modal from "@/components/shared/modal";
import { SETTINGS } from "@/constants/common/settings";

type Props = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
};

/* ファイルアップ時のエラー表示 */
const OverLimitModal: React.FC<Props> = ({ showModal, setShowModal }) => {
  const router = useRouter();

  return (
    <Modal
      show={showModal}
      showClose={true}
      title="エラーが発生しました"
      titleRed={true}
      setShow={setShowModal}
    >
      <div className="m-24 mt-0">
        <p className="text-md font-normal">
          1回あたり同時にアップロードできる枚数は
          <span className="font-medium text-cErrorRed">
            {SETTINGS.PHOTO.MAX_MULTI_UPLOAD_COUNT}枚
          </span>
          までとなっております。大変お手数ですが、再度写真のアップロード操作をお願い致します。
        </p>

        <div className="mt-8 text-center">
          <ButtonV2
            variant="primary"
            layout="fullWidth"
            click={() => {
              setShowModal(false);
              router.reload();
            }}
          >
            閉じる（再読み込みをします）
          </ButtonV2>
        </div>
      </div>
    </Modal>
  );
};

export default OverLimitModal;
